// Constants around the authentication process

export const LOGIN_ROUTE = '/insights/login'
export const CALLBACK_ROUTE = '/login-callback'
export const ROOT_ROUTE = '/insights/attentionindex'
export const ROOT_ROUTE_CALENDAR = '/insights/calendar'
